import * as React from "react";
import { PortfolioSummaryCard } from "../PortfolioSummaryCard";
import { QueryStateBoundary } from "@/components/dashboard/QueryStateBoundary";
import { usePortfolioSummary } from "@/hooks/queries/usePortfolio";
import { appConfig } from "@/utils/config";

interface PortfolioSummaryPayload {
  cash: number;
  position_count: number;
  holding_count: number;
  updated_at: string;
}

/**
 * Backend v2.1 (Sprint 4.2) `GET /api/v1/portfolio/summary` - a genuine
 * read of whatever `PortfolioPipeline` has already persisted for
 * `appConfig.defaultPortfolioId`. Replaces the Sprint 3.3-era
 * always-`null` placeholder rendering. `portfolioValue`/`availableMargin`
 * remain "Not reported by backend": `PortfolioSummaryResponseDto` has no
 * such fields (only `cash`/`position_count`/`holding_count`/
 * `updated_at`) - rendering either would be a fabricated value.
 */
export function PortfolioSummarySection(): React.JSX.Element {
  const summaryQuery = usePortfolioSummary(appConfig.defaultPortfolioId);

  return (
    <QueryStateBoundary query={summaryQuery}>
      {(payload) => {
        const summary = payload as unknown as PortfolioSummaryPayload;
        return (
          <PortfolioSummaryCard
            data={{
              portfolioValue: null,
              cashBalance: summary.cash,
              availableMargin: null,
              holdingsCount: summary.holding_count,
              openPositionsCount: summary.position_count,
              lastUpdated: summary.updated_at,
            }}
          />
        );
      }}
    </QueryStateBoundary>
  );
}
